import axios from "axios";
import { API_BASE_URL } from "../utils/api";

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

// Response interceptor for consistent error handling
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const currentPath = window.location.pathname;
        const isSignInPage = currentPath.includes("/sign-in") || currentPath.includes("/login");

        // Standard error handling
        if (error.response?.status === 401) {
            // Clear session storage
            localStorage.removeItem("user");
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("accessToken");

            // Prevent redirect loop if already on sign-in
            if (!isSignInPage) {
                window.location.href = "/sign-in";
                return Promise.reject(error); // Stop propagation if redirecting
            }
        }

        // Standardize error message extraction
        const message =
            error.response?.data?.message ||
            error.response?.data?.data?.message ||
            error.response?.data?.error ||
            error.response?.data?._dev?.technicalMessage ||
            error.message ||
            "An unexpected error occurred";

        // Create a new error object with the standardized message
        const customError = new Error(message);
        customError.status = error.response?.status;
        customError.originalError = error;
        customError.data = error.response?.data; // Preserve data for further inspect if needed

        return Promise.reject(customError);
    }
);

export default axiosInstance;
